// extracted by mini-css-extract-plugin
export default {"skeleton":"styles_skeleton__w7bv0","shimmer":"styles_shimmer__ACn+k","date-time":"styles_date-time__cAQor","duration":"styles_duration__rp1rv","overall":"styles_overall__Il51h"};